<script setup>
    import { computed, onMounted, onUnmounted } from 'vue'

    import PreviewIncentives from '@/components/previews/PreviewIncentives.vue'
    import PreviewBusinessPartnerList from '@/components/previews/PreviewBusinessPartnerList.vue'
    import PreviewLeadGeneration from '@/components/previews/PreviewLeadGeneration.vue'
    import PreviewActivity from '@/components/previews/PreviewActivity.vue'
    import PreviewPerformanceFacility24 from '@/components/previews/PreviewPerformance-facility24.vue'
    import PreviewPerformanceFacility25 from '@/components/previews/PreviewPerformance-facility25.vue'
    import PreviewReviews from '@/components/previews/PreviewReviews.vue'
    import PreviewFunnelAnalysis from '@/components/previews/PreviewFunnelAnalysis.vue'

    import Reminder from '@/components/Reminder.vue'
    import { useChangelogStore } from '@/stores/changelog'

    import { useIncentivesStore } from '@/stores/incentives'
    const incentivesStore = useIncentivesStore();

    import { useBusinessPartnersStore } from '@/stores/businessPartners'
    const businessPartnersStore = useBusinessPartnersStore();

    import { useBusinessPartnersCountStore } from '@/stores/businessPartnersCount'
    const businessPartnersCountStore = useBusinessPartnersCountStore();

    import { useUserStore } from '../stores/user'
    const userStore = useUserStore();
    const changelogStore = useChangelogStore();
    const moduleFlags = computed(() => {
        return {
            incentive: userStore.hasModule('Incentive'),
            performance: userStore.hasModule('Performance'),
            activity: userStore.hasModule('Activity'),
            ratings: userStore.hasModule('Bewertungen'),
            leadGeneration: userStore.hasModule('Eigenrecherche'),
        };
    });
    
    onMounted(async() => {
        if (userStore.currentSelection.campaign.id===null) await userStore.selectCampaign(userStore.idCampaignLogin);
    })

    function handleDisplayPopUp(type) {
        const signature = `${userStore.currentSelection?.salesAgent?.id}:${userStore.currentSelection.campaign.id}#ToDo:${type}`;
        return businessPartnersStore.businessPartnerListBySignature(signature).length > 0;
    }

    const exceededToDos = computed(() => {
        if (!userStore.isSalesAgent) return null;
        if (userStore.lastName === 'vom Hofe') return null; // debug only
        const salesPitchFollowUps = businessPartnersStore.businessPartnerListBySignature(`${userStore.currentSelection?.salesAgent?.id}:${userStore.currentSelection.campaign.id}#ToDo:Wiedervorlagen`);
        const salesPitchFeedbacks = businessPartnersStore.businessPartnerListBySignature(`${userStore.currentSelection?.salesAgent?.id}:${userStore.currentSelection.campaign.id}#ToDo:VorOrtTermine`);
        return {
            both: (salesPitchFollowUps || []).length > userStore.maxToDos.followUp && (salesPitchFeedbacks || []).length > userStore.maxToDos.feedback,
            followUps: (salesPitchFollowUps || []).length > userStore.maxToDos.followUp,
            feedbacks: (salesPitchFeedbacks || []).length > userStore.maxToDos.feedback
        }
    });

    const hasUnseenChangelog = computed(() => changelogStore.hasUnseen);

    
</script>

<template>
    <div class="reminder-wrapper dashboard max-width">
        <!-- <div v-if="exceededToDos" class="potentialpopUp">
            <div class="contentWrapper">
                <div class="header">
                    <img src="@/assets/imgs/icons/triangle-exclamation-solid.svg" alt="Obacht!">
                </div>
                <div class="warningText">
                    <h2>Warnung!</h2>
                    <p v-if="exceededToDos.both">Die maximale Anzahl unbearbeitetem Termin-Feedback von {{ userStore.maxToDos.feedback }} und Wiedervorlagen wurde erreicht. Bitte bearbeite ältere Termine und Wiedervorlagen, um fortzufahren.</p>
                    <p v-else-if="exceededToDos.feedbacks">Die maximale Anzahl unbearbeitetem Termin-Feedback von {{ userStore.maxToDos.feedback }} wurde erreicht. Bitte bearbeite ältere Termine, um fortzufahren.</p>
                    <p v-else>Die maximale Anzahl unbearbeiteter Wiedervorlagen von von {{ userStore.maxToDos.followUp }} wurde erreicht. Bitte bearbeite ältere Wiedervorlagen, um fortzufahren.</p>
                </div>
                <div><router-link to="/salesPitchFollowUp" :class="['warning-btn warning-follow-up', {'negative' : businessPartnersStore.businessPartnerListBySignature(`${userStore.currentSelection?.salesAgent?.id}:${userStore.currentSelection.campaign.id}#ToDo:Wiedervorlagen`).length > 0}]" >Wiedervorlagen To-Do<span class="number-label">{{ businessPartnersStore.businessPartnerListBySignature(`${userStore.currentSelection?.salesAgent?.id}:${userStore.currentSelection.campaign.id}#ToDo:Wiedervorlagen`).length}}</span></router-link></div>
                <div><router-link to="/salesPitchFeedback" :class="['warning-btn warning-appointments', {'negative' : businessPartnersStore.businessPartnerListBySignature(`${userStore.currentSelection?.salesAgent?.id}:${userStore.currentSelection.campaign.id}#ToDo:VorOrtTermine`).length > 0}]">Termin-Feedback<span class="number-label">{{ businessPartnersStore.businessPartnerListBySignature(`${userStore.currentSelection?.salesAgent?.id}:${userStore.currentSelection.campaign.id}#ToDo:VorOrtTermine`).length}}</span></router-link></div>    
            </div>
        </div>  -->
        <template v-if="userStore.tag === 'user'">
            <main :class="['dashboard', userStore.currentSelection.campaign?.id ? `campaign-${userStore.currentSelection.campaign.id}` : 'no-campaign', {'compact-tables': userStore.preferences.widgets.dashboard.compactTables}]">
                <!-- Changelog-Banner: schmal, full-width, nur wenn neueste Version ungelesen -->
                <section v-if="hasUnseenChangelog" class="changelog-banner">
                    <div class="changelog-banner-inner">
                        <div class="changelog-icon">
                            <img src="@/assets/imgs/icons/book-solid.svg" alt="" aria-hidden="true" />
                        </div>
                        <div class="changelog-content">
                            <span class="changelog-label">Neuer Changelog</span>
                            <span class="changelog-text">
                                Du hast einen ungelesenen Changelog im SMA-Portal. Bitte schau dir den aktuellen Eintrag an.
                            </span>
                        </div>
                        <router-link class="changelog-link" :to="{ name: 'Changelog' }">
                            Jetzt ansehen
                        </router-link>
                    </div>
                </section>
                <!-- Incentives -->
                <template v-if="moduleFlags.incentive && userStore.preferences.widgets.dashboard.showIncentives">
                    <preview-incentives />
                </template>
                
                


                <!-- Business Partner List (acts as hub; only hide if NONE of dependent modules available) -->
                <template v-if="(moduleFlags.performance || moduleFlags.activity || moduleFlags.ratings || moduleFlags.leadGeneration || moduleFlags.incentive) && userStore.preferences.widgets.dashboard.showPerformance">
                    <preview-business-partner-list />
                </template>
                

                <!-- Lead Generation -->
                <template v-if="moduleFlags.leadGeneration && userStore.preferences.widgets.dashboard.showPerformance">
                    <preview-lead-generation />
                </template>
                

                <!-- Activity -->
                <template v-if="moduleFlags.activity && userStore.preferences.widgets.dashboard.showActivity">
                    <preview-activity />
                </template>
                

                <!-- Performance (campaign dependent) -->
                <template v-if="moduleFlags.performance && userStore.preferences.widgets.dashboard.showPerformance">
                    <preview-performance-facility24 v-if="userStore.currentSelection.campaign.id <= 22" />
                    <preview-performance-facility25 v-else />
                </template>
                

                <!-- Reviews -->
                <template v-if="moduleFlags.ratings && userStore.preferences.widgets.dashboard.showRatings">
                    <preview-reviews />
                </template>

                <!-- Funnel Analysis (manager only) -->
                <!-- <template v-if="(userStore.currentSelection.campaign?.company?.id === 1) && (userStore.isManagement || userStore.isSalesTeamManager || userStore.isWinback)">
                    <preview-funnel-analysis />
                </template> -->
                
            </main>
            <reminder></reminder>
            <!-- <div v-if="moduleFlags.incentive" class="disclaimer-wrapper">
                <div class="widget-wrapper">
                    <div class="container-wrapper">
                        <div class="container disclaimer">
                            <p>Aktualisiert am {{ incentivesStore?.incentive?.salesAgents?.dateUpdated?.split(', ')[0]}}<br><br><span class="asterisk">&#42;&sup1;</span> {{ incentivesStore.incentive?.salesAgents?.disclaimer}}</p>
                            <p><span class="asterisk">&#42;&sup²;</span> {{ incentivesStore?.incentive?.salesTeams?.disclaimer}}</p>
                            <p><span class="asterisk">&#42;&sup³;</span> Diese Werte dienen nur der Orientierung und ersetzen nicht die Endabrechnung aus SAP.</p>
                        </div>
                    </div>
                </div>
            </div> -->
        </template>
        <template v-else>

        </template>
    </div>
</template>

<style scoped>
                .changelog-banner {
                    width: 100%;
                    margin-bottom: 0.75rem;
                }

                .changelog-banner-inner {
                    display: flex;
                    align-items: center;
                    gap: 0.85rem;
                    padding: 0.6rem 1rem;
                    border-radius: var(--sellwerk-border-radius);
                    background: rgba(255, 255, 255, 0.96);
                    border: 1px solid rgba(234, 88, 12, 0.35);
                    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
                }

                .changelog-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                }

                .changelog-icon img {
                    width: 18px;
                    height: 18px;
                    display: block;
                    filter: var(--color-sellwerk-grade-two-filter);
                }

                .changelog-content {
                    display: flex;
                    flex-direction: column;
                    gap: 0.1rem;
                    flex: 1;
                }

                .changelog-label {
                    font-size: 0.7rem;
                    font-weight: 800;
                    text-transform: uppercase;
                    letter-spacing: 0.14em;
                    color: var(--color-sellwerk-grade-one);
                }

                .changelog-text {
                    font-size: 0.82rem;
                    color: var(--sellwerk-color-dark-2);
                }

                .changelog-link {
                    font-size: 0.75rem;
                    font-weight: 600;
                    text-decoration: none;
                    padding: 0.32rem 0.95rem;
                    border-radius: 999px;
                    background: var(--sellwerk-color-main-accent);
                    color: var(--sellwerk-color-light);
                    border: 1px solid rgba(0, 0, 0, 0.04);
                    white-space: nowrap;
                    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.18);
                }

                .changelog-link:hover {
                    background: #ff8f1a;
                }

                @media (max-width: 720px) {
                    .changelog-banner-inner {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .changelog-link {
                        width: 100%;
                        text-align: center;
                    }
                }
                </style>